var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import CtaButton from './CtaButton';
import { localizeUrl } from '../core/helpers/url-helper';
var ProductItemWithDescription = /** @class */ (function (_super) {
    __extends(ProductItemWithDescription, _super);
    function ProductItemWithDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductItemWithDescription.prototype.render = function () {
        var _this = this;
        var product = window.App.products.find(function (item) { return item.id === _this.props.itemId; });
        if (!product) {
            return null;
        }
        return (React.createElement("div", { className: "c-product-item-with-description" },
            React.createElement("div", { className: "c-product-item-with-description__image", style: { backgroundImage: "url(/images/home/products/" + product.id + ".jpg?v3)" } },
                React.createElement("div", { className: "c-product-item-with-description__image__content" },
                    this.props.t('landing.products.main.badge') && (React.createElement("div", { className: "c-badge c-badge--white" }, this.props.t('landing.products.main.badge'))),
                    React.createElement("h1", null, this.props.t('landing.products.main.title')),
                    React.createElement("p", null,
                        React.createElement(Trans, { i18nKey: "landing.products.main.price" },
                            React.createElement("span", { className: "h-text-decoration--line-through" }))))),
            React.createElement("div", { className: "c-product-item-with-description__description" },
                React.createElement("div", { className: "c-product-item-with-description__description__content" }, this.props.t('landing.products.main.description')),
                React.createElement("div", { className: "c-product-item-with-description__description__cta" },
                    React.createElement(CtaButton, { link: localizeUrl("/products/" + product.slug), label: "button.learn_more", icon: "arrow-right", modifier: ['yellow', 'shadow'] })))));
    };
    return ProductItemWithDescription;
}(React.Component));
export default withTranslation()(ProductItemWithDescription);
